
import React, { useState, FormEvent, useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

interface TerminalInputProps {
  prompt?: string;
  onCommand?: (command: string) => void;
  className?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  containerRef?: React.RefObject<HTMLDivElement>;
}

export default function TerminalInput({
  prompt = "$",
  onCommand,
  className,
  autoFocus = false,
  disabled = false,
  containerRef,
}: TerminalInputProps) {
  const [command, setCommand] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (command.trim() && onCommand) {
      onCommand(command);
      setCommand("");
      //scroll to input
      setTimeout(() => {
        if (containerRef && containerRef.current) {
          containerRef.current.scrollTop = containerRef.current.scrollHeight
        }
      }
      , 100);
    }
  };

  return (
    <div className={cn("flex items-center space-x-2", className)}>
      <span className="text-terminal-green font-mono">{prompt}</span>
      <form onSubmit={handleSubmit} className="flex-1">
        <input
          ref={inputRef}
          type="text"
          value={command}
          onChange={(e) => setCommand(e.target.value)}
          className="w-full bg-transparent border-none outline-none focus:ring-0 p-0 text-foreground font-mono"
          placeholder="Type a command..."
          disabled={disabled}
          aria-label="Terminal input"
        />
      </form>
      <div className="w-2 h-4 bg-terminal-pink animate-blink" />
    </div>
  );
}
